import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';


import {
    ExcelExport,
    ExcelExportColumn,
    ExcelExportColumnGroup
} from '@progress/kendo-react-excel-export';


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class FractionUnits extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],
			
			search_type: "date",

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",

			table_list:[],
			listado:[],

			change_check: false,

			columns:[
				{title: 'No. Donación'},
				{title: 'Donador'},
				{title: 'Componente Origen'},
				{title: 'Fecha'},
				{title: 'Componentes Obtenidos'},
			],
			filename: "Unidades Fraccionadas",
			totales:[],

			num_comp:"",
			xls_columns:[],
			listado_xls:[],
			extraction_name:"",
			convoke_places_name:"",
			process_type:"all",
			date_hour:"",
			medical:"",
			blood_bags:[],
			blood_bags_id:"all",
			apheresis:[],
			apheresis_kit_id:"all"
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				blood_bags: response
			})
		})

		fetch(Config.default.apiGateway.URL+'apheresis_kits',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				apheresis: response
			})
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getConvokePlace();

		fetch(Config.default.apiGateway.URL+'donation_type_extraction', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					extraction_type: response
				});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	 _exporter;
	setTable(){
		var fechas = this.state.search_type === 'date' ?
			"Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
			" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		: ""

		this.$el = $(this.el);

		var totales = ""
		this.state.totales.map((t, i)=>{
			return totales += t.code+'= '+t.count+'; '
		})
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	text: 'Excel',
	                action: ( e, dt, node, config ) => {
	                     this._exporter.save();
	                }
	            },
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
                		doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},
							]
						});
                		doc.content[5] = {
							text:totales,
							margin:[5,15,0,0]
            			}
            			doc.defaultStyle.fontSize = 6; 
                		doc.styles.tableHeader.fontSize = 7;

                		if(this.state.process_type !== 'especial'){
                		//	doc.content[4].table.widths =  ["10%","25%", "15%","10%","40%"];
                		}
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};

                	} 
            	}
            ],
            
            order: this.state.process_type === 'especial' ? [[1, "asc"]] : [[0, "asc" ]],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
		});


		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});			

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);		
		}

		if(e.target.name === 'search_type'){
			if(e.target.value === 'date'){
				this.setState({
					start_folio: "",
					end_folio: ""
				});
			}else{
				this.setState({
					start_date 	: "",
					end_date 	: ""
				});
			}
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})

			if(e.target.options[e.target.selectedIndex].text === 'SANGRE TOTAL'){
				this.setState({apheresis_kit_id:'all'});
			}else if(e.target.options[e.target.selectedIndex].text === 'AFÉRESIS'){
				this.setState({blood_bags_id:'all'});
			}else{
				this.setState({apheresis_kit_id:'all', blood_bags_id:'all'});
			}
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					extraction_type_id: this.state.extraction_type_id,
					process_type:this.state.process_type === 'especial' ? 'all' : this.state.process_type,
					health_facilities_id:this.state.health_facilities_id,
					blood_bags_id: this.state.blood_bags_id,
					apheresis_kit_id: this.state.apheresis_kit_id
				}
			
				fetch(Config.default.apiGateway.URL+'reports/division_program',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var list = [];
						var mayor = 0;
						var list_xls = [];
						var columns = [];

						if(this.state.process_type === 'especial'){
							
							columns = [
								{title:'Hora Extracción'},
								{title:'No. Bolsa'},
								{title:'Donador'},
								{title:'Vol. Extracción ST(ml)'},
								{title:'Duración Extracción'}
							]
						
							response.total.map((t)=>{
								if(t.code !== 'ST'){
									this.setState({
										columns:[...this.state.columns, {
											title:t.code+'(ml)'
										}]
									})
								}
							});
						}else{
							columns = [
								{title: 'No. Donación'},
								{title: 'Donador'},
								{title: 'Componente Origen'},
								{title: 'Fecha'},
								//{title: 'Componentes Obtenidos'},
							];
							
							response.total.map((t)=>{
								columns.push({title:t.code, code:t.code});

							});
							
						}

						columns.push({title: 'Usuario Fraccionó'})

						this.setState({
							columns:columns,
							//table_list: response,
							listado: [],
							xls_columns: [],
						});


						response.res.map((r, i)=>{
							var obj = [];
							var components = '';

							if(this.state.process_type === 'especial'){
								obj.push(
									moment(r.timestamp_hour, 'H:mm:ss').format('HH:mm'),
									r.donation_number,
									r.donor_name,
								)

								var orig_vol = '';
								r.original_component.map((orig, i)=>{
									if(orig.code === 'ST'){
										orig_vol += orig.volume;
									}else{
										orig_vol = '';
									}
								});

								obj.push(orig_vol, r.extraction_time);

								if(mayor < r.components.length){
									mayor = r.components.length;
								}

								response.total.map((t)=>{
									if(t.code !== 'ST'){
										var index = r.components.findIndex(item =>
											item.code === t.code
										)

										if(index !== -1){
											obj.push(r.components[index].volume);
										}else{
											obj.push('');
										}
									}
								});

							}else{
								obj.push(
									r.donation_number !== undefined ? r.donation_number : r.unit_number,
									r.donor_name
								);

								var original = '';
								r.original_component.map((orig, i)=>{
									original += orig.code+'('+orig.volume+' ml);'
								});

								obj.push(original, r.timestamp_date);

								if(mayor < r.components.length){
									mayor = r.components.length;
								}

								columns.map((col)=>{
									if(col.code !== undefined){
										var index = r.components.findIndex(item => 
											item.code === col.code
										);

										if(index !== -1){
											obj.push('('+r.components[index].volume+' ml)');
										}else{
											obj.push('');
										}
									}
								});
								/*r.components.map((c)=>{
									return components += c.code+'('+c.volume+' ml); ';
								});*/

								//obj.push(components.substring(0, components.length - 2));
							}

							obj.push(r.user);

							list.push(obj);
						});

						
						this.setState({
							listado: list,
							totales: response.total,
							num_comp: mayor,
						});
						

						//excel
						this.state.columns.map((col, i)=>{
							if(this.state.process_type !== 'especial'){
								if(i <= 3){
									this.setState({
										xls_columns: [...this.state.xls_columns, {title:col.title}]
									})
								}
							}else{
								
								this.setState({
									xls_columns: [...this.state.xls_columns, {title:col.title}]
								})
							}
								
						});
						
						if(this.state.process_type !== 'especial'){
							for(var i=0; i<mayor; i++){
								this.setState({
									xls_columns: [...this.state.xls_columns, {title:'Comp '+(i+1)}]
								})
							}
						}
						
						this.setState({
							xls_columns: [...this.state.xls_columns, {title:'Usuario Fraccionó'}]
						})

						response.res.map((r)=>{
							var obj = {};

							if(this.state.process_type === 'especial'){
								obj.Hour = moment(r.timestamp_hour, 'H:mm:ss').format('HH:mm');
								obj.N_Donacion = r.donation_number;
								obj.Donador = r.donor_name;
								obj.ST = r.original_component !== null ? parseInt(r.original_component.volume) : '';
								obj.Time = r.extraction_time;
							
								response.total.map((t)=>{
									if(t.code !== 'ST'){
										var index = r.components.findIndex(item =>
											item.code === t.code
										)

										if(index !== -1){
											obj[t.code+'(ml)'] = parseInt(r.components[index].volume);
										}else{
											obj[t.code+'(ml)'] = '';
										}
									}
								});

							}else{
								obj['N_Donacion'] = r.donation_number;
								obj.Donador = r.donor_name;
								obj.Fecha = r.timestamp_date;

								r.components.map((c, i)=>{
									return  obj['Comp '+(i+1)] = c.code+'('+c.volume+' ml)';
								});

								if(r.components.length < mayor){
									for(var i = r.components.length; i<mayor; i++){
										obj['Comp '+(i+1)] = '';
									}
								}
							}
								
							obj['Usuario Fraccionó'] = r.user;

							return list_xls.push(obj);
						});
						
						
						this.setState({listado_xls: list_xls});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}
	
 	export = () => {
        this._exporter.save();
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Procesado ->
					{t('sidebar.nav.reports.fraction_units')}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>
								
								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}
									
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.donation_type_extraction.id}>
												{don.lookup_value}
											</option>
										})}
									</select>
								</div>

								{this.state.extraction_type_name === "SANGRE TOTAL" ?
									<div className="form-group" >
										<span className="span-min">{t('content.extractions.st.blood_bags_id')}</span>
										<select className="form-control bio_extraction" value={ this.state.blood_bags_id || ""} 
											onChange={ this.handleChange.bind(this) } name="blood_bags_id" 
											id="blood_bags_id"  required>
											<option value="" disabled>Seleccionar...</option>
											<option value="all" >TODOS</option>
											{
												this.state.blood_bags.map(function(t) {
													return <option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>;
												})
											}
										</select>
									</div>
								: this.state.extraction_type_name === "AFÉRESIS" ?
									<div className="form-group">
										<span className="span-min">{t('content.extractions.apheresis.apheresis_kits_id')}</span>
										<select className="form-control bio_extraction" value={ this.state.apheresis_kit_id || ""} 
											onChange={ this.handleChange.bind(this) } name="apheresis_kit_id" 
											id="apheresis_kit_id" required>
											<option value="" disabled>Seleccionar...</option>
											<option value="all">TODOS</option>
											{
												this.state.apheresis.map(function(t){
													return <option key={t.apheresis_kit.id} value={t.apheresis_kit.id} >{t.apheresis_kit.name}</option>;
												})
											}
										</select>
									</div>
								: null}

								<div className="form-group">
									<span className="span-min">Tipo de Proceso</span>
									<select className="form-control" name="process_type" id="process_type"
										value={this.state.process_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										<option value="special">ESPECIAL</option>
										<option value="crioprecipitate_process">CRIOPRECIPITADOS</option>
										<option value="division_program">FRACCIONAMIENTO</option>
										
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Unidades Fraccionadas
										</span>
									</div>
									{this.state.search_type === 'date' ?
										<div className="col-xs-12" >
											<span>
												Información Del:  {this.state.start_date !== "" ?
													moment(this.state.start_date).format("DD/MM/YYYY")
												: ''}    
											</span>
											<span style={{marginLeft:"5px"}}>	
												Al: {this.state.end_date !== "" ?
													moment(this.state.end_date).format("DD/MM/YYYY")
												: ''}
											</span>
										</div>
									: null}

									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>	
										:null}
									</div>
										
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									{this.state.totales.map((t, i)=>{
										return <span key={i}>
											{t.code+'= '+t.count+';  '}
										</span>
									})}
								</div>
							</div>
						</form>
					</div>
				</div>

				<div>
	                <ExcelExport
	                    data={this.state.listado_xls}
	                    fileName={this.state.filename}
	                    ref={(exporter) => { this._exporter = exporter; }}
	                >
	                	<ExcelExportColumnGroup title={this.state.filename} 
	                		headerCellOptions={{ textAlign: 'center', background:'#FFF', color:'#000' }}
	                		>
		                	{this.state.xls_columns.map((col, i)=>(
		                		<ExcelExportColumn key={i} field={
		                				col.title === 'No. Donación' || col.title === 'No. Bolsa' ? 'N_Donacion' :
		                				col.title === 'Hora Extracción' ? 'Hour' :
		                				col.title === 'Vol. Extracción ST(ml)' ? 'ST' :
		                				col.title === 'Duración Extracción' ? 'Time' :
		                				/*
		                				{title:'No. Bolsa'},
									{title:'Donador'},
									{title:'Vol. Extracción ST(ml)'},
									{title:'Duración Extracción'}


		                				:*/ col.title
		                			} 
		                			title={col.title} 
		                			headerCellOptions={{background: '#FFF', color:'#000', bold: true, 
		                				borderBottom:{color:'#aaa8a8', size:'1'},
		                				borderLeft:{color:'#aaa8a8', size:'1'},
		                				borderRight:{color:'#aaa8a8', size:'1'},
		                				borderTop:{color:'#aaa8a8', size:'1'}
		                			}} />
		                	))}
	                	</ExcelExportColumnGroup>
	                </ExcelExport>
	            </div>
			</div>
		)
	}
}

export default translate('translations') (FractionUnits);